import { Box, Typography } from "@mui/material"
import { DialogBox } from "lib/@components/dialogBox"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringDeleteDialog({ value, title, message, messageSx = {} }) {
    return (
        <DialogBox
            title={
                <Box display="flex" alignItems="center" gap={1}>
                    <Iconify icon="material-symbols:info" width={24} height={24} />
                    <Typography variant="h5">{title}</Typography>
                </Box>
            }
            value={value}
            okColor="error"
            okCaption="Remove"
            okIcon="gravity-ui:trash-bin"
            cancelColor="text"
            data-cy="delete-dialog"
        >
            <If value={message}>
                <Typography mt={3} sx={messageSx} color="textSecondary">
                    {message}
                </Typography>
            </If>
        </DialogBox>
    )
}
